import React from "react";
const AlbumIcon = require("../styles/images/GreenAlbum.svg");

export const NoEvents: React.FC = () => {
  return (
    <div className="geo-display-center">
      <div className="ws-no-items-container" id="cl-no-events">
        <div className="ws-white-circle">
          <img src={AlbumIcon} alt="No events" className="ws-no-items-image" />
        </div>
        <h2 className="ws-no-items-title">Content Manager</h2>
        <p className="ws-no-items-text">
          This is where you can manage all your events, albums, and photos.
        </p>
        <p className="ws-no-items-text">Create an event to get started.</p>
        <a
          href={"/dashboard/events/new/our"}
          className="geo-btn geo-btn--secondary geo-btn--caps"
        >
          Create an Event
        </a>
      </div>
    </div>
  );
};
